<template style="height: 100%;">
  <div class="File_list">
    <div class="File_list_top">
    <el-form style="margin-top: 15px;" :inline="true" :model="form" class="demo-form-inline">
      <el-form-item>
        <el-input v-model="form.Content" placeholder="请输入搜索关键词"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button style="margin-top: 3px;" type="primary" @click="search()">搜索</el-button>
        <el-button style="margin-top: 3px;" type="primary" @click="Add()">+个人档案</el-button>
        <el-button style="margin-top: 3px;" type="primary">批量导入测评记录</el-button>
      </el-form-item>
    </el-form>
    </div>
    <div style="margin-top: 10px;width: 98%;margin-left: 1%;">
      <el-table :data="tableData" stripe style="width: 100%">

        <el-table-column label="序号" min-width="60px" align="left">
          <template slot-scope="scope" center>
            {{ (pageIndexs - 1) * 10 + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column label="军人证件号">
          <template slot-scope="scope">
            <span>{{ scope.row.UserID }}</span>
          </template>
        </el-table-column>

        <el-table-column label="姓名">
          <template slot-scope="scope">
            <span>{{ scope.row.RealName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="性别">
          <template slot-scope="scope">
            <span>{{ scope.row.Sex }}</span>
          </template>
        </el-table-column>

        <el-table-column label="年龄">
          <template slot-scope="scope">
            <span>{{ scope.row.Age }}</span>
          </template>
        </el-table-column>

        <el-table-column label="技术级别">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="文职级别">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column label="是否退役">
          <template slot-scope="scope">
            <span>{{ scope.row.State }}</span>
          </template>
        </el-table-column>

        <el-table-column label="身体状况">
          <template slot-scope="scope">
            <span>{{ scope.row.Bak6 }}</span>
          </template>
        </el-table-column>

        <el-table-column label="心理状况">
          <template slot-scope="scope">
            <span>{{ scope.row.Bak5 }}</span>
          </template>
        </el-table-column>
 
        <el-table-column label="学历">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="操作" width="400">
          <template slot-scope="scope">
            <el-tag size="small" style="cursor:pointer" @click="View(scope.row.UserID)">查看档案</el-tag>
            <el-tag size="small" style="margin-left: 10px;cursor:pointer">编辑档案</el-tag>
            <el-tag size="small" style="margin-left: 10px;cursor:pointer" @click="File_add_consultation(scope.row.UserID)">+咨询记录</el-tag>
            <el-tag size="small" style="margin-left: 10px;cursor:pointer" @click="File_add_record(scope.row.UserID)">+重要记录</el-tag>

            <!-- <el-button size="mini" type="primary">编辑档案</el-button>
            <el-button size="mini" type="primary">+咨询记录</el-button>
            <el-button size="mini" type="primary">+重要记录</el-button> -->

          </template>

        </el-table-column>

      </el-table>
    </div>

    <div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage1" :page-size="10" layout="total, prev, pager, next" :total="Counts">
      </el-pagination>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPage1: 1,
      pageIndexs: 10,
      Counts: 0,
      form: {
        Content:'',
      },
      tableData: []
    }
  },
  components: {

  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage1 = val
      this.load();
    },
    search() {
      this.currentPage1 = 1;
      this.load();
    },
    Add() {
      this.$router.push('/Archives_management/Personal_file');
    },

    File_add_record(val) {
      this.$router.push({
        path: '/Archives_management/File_add_record',
        query: { id: val },
      })
    },
    File_add_consultation(val) {

      this.$router.push({
        path: '/Archives_management/File_add_consultation',
        query: { id: val },
      })
    },

    load() {
      this.$Http_Post('SoldierFile/SoldierList', { 'PageIndex': this.currentPage1, "PageSize": '10', "name": this.form.Content }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Counts = res.Counts
          this.tableData = res.Data;
        } else {

        }
      })
    },
    View(val) {

      this.$router.push({
        path: '/Archives_management/File_view',
        query: { id: val},
      })
    }
  },
  watch: {

  },
  mounted() {
    this.load();
  }
}
</script>
<style>
.File_list{height: 100%;background-color: #fff;}
.File_list_top{height: 70px;border: 1px solid rgba(225, 226, 227, 1);}
.File_list_top input{display: inline-block;width: 300px;margin-left: 20px;}
.File_list_top button{float: left;}
</style>
